import { Grid, Theme } from '@material-ui/core'
import LinearProgress from '@material-ui/core/LinearProgress'
import { makeStyles } from '@material-ui/core/styles'
import { FC, useEffect } from 'react'
import { connect } from 'react-redux'
import loginImage from '../../../images/logInImage.svg'
import {
  selectIsAdminUser,
  selectUserIsAuthenticated
} from '../../../selectors/users'
import { getCurrentUserInfo } from '../../../services/auth/auth'
import { StateInterface } from '../../../types/states'
import BeforeLoginApartmentSuccessDialog from './Dialogs/BeforeLoginApartmentSuccessDialog'
import EmailConfirmationResultDialog from './Dialogs/EmailConfirmationResultDialog'
import LoginWindow from './LoginWindow'

const useStyles = makeStyles(({ breakpoints, palette }: Theme) => ({
  loginScreen: {
    maxWidth: '90%',
    textAlign: 'center',
    position: 'fixed',
    bottom: '10vh',
    [breakpoints.down('sm')]: {
      maxWidth: '100vw',
      bottom: '10px',
      position: 'relative'
    },
    [breakpoints.up('md')]: {
      width: '100vw'
    }
  },
  loginImage: {
    maxHeight: '100vh',
    maxWidth: '100vw',
    [breakpoints.up('xs')]: {
      marginTop: '30px',
      maxWidth: '50vw'
    },
    [breakpoints.up('md')]: {
      display: 'inline-flex',
      height: '75vh',
      maxWidth: '30vw'
    },
    [breakpoints.up('lg')]: {
      height: '75vh'
    }
  },
  // TODO fix loginForm resizing issue
  loginForm: {
    '& > div': {
      width: '100%'
    },
    [breakpoints.down('sm')]: {},
    [breakpoints.up('md')]: {
      display: 'flex',
      width: '30vw'
    },
    [breakpoints.up('md')]: {
      display: 'flex'
    },
    [breakpoints.up('xl')]: {
      display: 'flex',
      height: '300px'
    }
  },
  modalTitle: {
    margin: '30px',
    paddingTop: '5px',
    [breakpoints.down('sm')]: {
      fontSize: '1.2rem',
      margin: '20px 0'
    }
  },
  primaryBtn: {
    font: '14px CircularRegular',
    borderRadius: '10px',
    display: 'flex',
    justifyContent: 'center',
    textDecoration: 'none',
    textTransform: 'capitalize',
    backgroundColor: '#94004A',
    padding: '15px 0',
    color: '#fff',
    marginBottom: '15px',
    '&:hover': {
      backgroundColor: '#670033'
    }
  },
  textButton: {
    color: '#002A92',
    cursor: 'pointer'
  },
  list: {
    margin: '0 30px 30px 30px',
    [breakpoints.down('sm')]: {
      margin: '0 10px 30px 0'
    },
    counterReset: 'item'
  },
  listItem: {
    padding: '0',
    [breakpoints.only('xs')]: {
      display: 'initial'
    }
  },
  listNumber: {
    color: '#fff',
    font: '1.5rem CircularRegular',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#002A92',
    minWidth: '56px',
    height: '56px',
    borderRadius: '400px',
    counterIncrement: 'item',
    '&::before': {
      content: 'counter(item)'
    },
    [breakpoints.only('xs')]: {
      margin: '10px 20px 5px 10px',
      float: 'left',
      minWidth: '45px',
      height: '45px',
      fontSize: '1.2rem'
    }
  },
  listText: {
    marginLeft: '25px',
    [breakpoints.only('xs')]: {
      marginLeft: '0'
    }
  },
  line: {
    margin: '7px 27px',
    padding: '0',
    width: '100%',
    height: '30px',
    borderLeft: '2px solid' + palette.grey[100]
  },
  arrowIcon: {
    position: 'absolute',
    height: '30px',
    width: '30px'
  }
  // // TODO test loginPaper style before applying
  // loginPaper: {
  //   display: 'flex',
  //   flexDirection: 'column',
  //   minWidth: '85%',
  //   padding: '25px 30px 25px 30px',
  //   [breakpoints.down('md')]: {
  //     padding: '35px 25px 45px 25px'
  //   },
  //   [breakpoints.down('sm')]: {
  //     padding: '15px 20px 15px 20px'
  //   }
  // }
}))

interface StateProps {
  isAdmin: boolean | undefined
  isAuthenticated: boolean | undefined
}

const mapStateToProps = (state: StateInterface): StateProps => ({
  isAdmin: selectIsAdminUser(state),
  isAuthenticated: selectUserIsAuthenticated(state)
})

type LoginProps = StateProps

const Login: FC<LoginProps> = ({ isAdmin, isAuthenticated }) => {
  useEffect(() => {
    if (isAuthenticated) {
      getCurrentUserInfo().then(async (res) => {
        window.analytics.identify(res.attributes.sub, {
          userName: res.attributes.name,
          email: res.attributes.email,
          phoneNumber: res.attributes.phone_number
        })
      })
    }
  }, [isAuthenticated])
  const classes = useStyles()
  return (
    <Grid
      container
      direction='row'
      justify='space-evenly'
      className={classes.loginScreen}
    >
      <Grid item xs={undefined} sm={undefined} md={8} lg={8} xl={8}>
        <img
          className={classes.loginImage}
          src={loginImage}
          alt='Man walking into open door'
        />
      </Grid>
      <Grid
        container
        item
        xs={12}
        sm={12}
        md={4}
        lg={4}
        xl={4}
        direction='column'
        justify='center'
      >
        {isAuthenticated ? (
          <LinearProgress />
        ) : (
          <Grid item className={classes.loginForm}>
            {/* perhaps add <Grid className={classes.loginPaper}> */}
            <Grid>
              <LoginWindow />
            </Grid>
          </Grid>
        )}
      </Grid>
      <EmailConfirmationResultDialog />
      <BeforeLoginApartmentSuccessDialog classes={classes} />
    </Grid>
  )
}

export default connect<
  StateProps,
  Record<string, never>,
  Record<string, never>,
  StateInterface
>(mapStateToProps)(Login)
